<div class="row">
  <form>
    <div class="row" style=" justify-content: space-between;">
     
      <div class="col-sm-3">
        <mat-form-field style="display: block !important;" appearance="outline">
          <mat-label>Country</mat-label>
          <mat-select #country id="country" [value]="selectedCountryIsoCode"
          (selectionChange)="applyFilters(country.value)">
            <mat-option [value]=""></mat-option>
            @for (country of countryList; track country) {
            <mat-option class="" [value]="country.countryIsoCode">{{country.bocmCountryName}}</mat-option>
            } 
          </mat-select>
        </mat-form-field>
      </div>
     
       <div class="col-sm-2" >
         <mat-icon style="cursor: pointer;"  [matBadge]="totalItem" matBadgeColor="accent" (click)="cart()">add_shopping_cart</mat-icon>
      </div> 
    </div>
  </form>
</div>